import parse from "html-react-parser";
import React, { useState } from "react";
import Chatbot from "../Chatbot/Chatbot";
import PropTypes from "prop-types";
import { contactSupportMobile } from "../../assets/images/icons";
import {
  ingestData,
  navigateToURL,
} from "../../bridges/BridgeServices";
import "./mobileContactSupport.scss";

import { close } from "../../assets/images/icons";
import {
  EVENTS,
  CHATBOT_CONTEXT,
} from "../../utils/constants";

const MobileContactSupport = ({
  supportBtnClassName = "",
  faqTitle = "",
}) => {
  const [shouldOpenChatbot, setOpenChatbot] = useState(
    false
  );

  return (
    <>
      <div
        className="support-close-icon hide"
        onClick={() => {
          setOpenChatbot(false);
          document
            .getElementById("mobile-chat-container")
            .click();

          if (document) {
            document.getElementsByClassName(
              "support-close-icon"
            )[0].style.display = "none";
            document
              .getElementsByClassName(
                "support-close-icon"
              )[0]
              .classList.add("hide");
          }
        }}
      >
        {parse(close)}
      </div>
      <button
        className={`support-button-mobile ${supportBtnClassName}`}
        style={{ display: "flex" }}
        onClick={() => {
          navigateToURL("CHATBOT");
          ingestData({
            name: EVENTS.CHATBOT_CLICKED,
            data: {
              context: CHATBOT_CONTEXT.GLOBAL,
              faqTitle,
            },
          });
        }}
      >
        {parse(contactSupportMobile)}
        <div className={"support-button-content"}>
          <p>Raise Ticket</p>
        </div>
      </button>
      <Chatbot shouldOpenChatbot={shouldOpenChatbot} />
    </>
  );
};

export default MobileContactSupport;

MobileContactSupport.propTypes = {
  supportBtnClassName: PropTypes.string,
  faqTitle: PropTypes.string,
};
